import type {Editor} from 'grapesjs';
import {MODALS_IDS} from '@Components/modal-container';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';

/** Opens the email-maker preview modal (renders the email HTML directly in a sandboxed iframe). */
export function openEmailMakerPreviewModal(editor: Editor): void {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.EMAIL_MAKER_PREVIEW_MODAL,
      panelProps: {editor},
    })
  );
}
